import axios from 'axios';

import { useState } from 'react';

import "./globals.css";
import "./main.css";
import "./styles/loaders.css";
import "./styles/home.css";

import aos from 'aos';

import { apiUrl } from '.';

import MindMap from './components/mindMap';
import FeedBack from './components/feedback';
import Banner from './components/banner';
import { Team } from './components/team';
import { About } from './components/about';
import Contact from './components/contact';
import Footer from './components/footer';
import NavBar from './components/navbar';
import { mouseEffect } from './components/mouseEffect';

import Cookies from './components/cookies';

import { useAlert } from 'react-alert';

import 'aos/dist/aos.css';

import { useEffect } from 'react';

export function ifMobile() {
  return window.innerWidth < 800;
}

export default function App() {
  const alert = useAlert();

  const [universityRecommendations, setUniversityRecommendations] = useState([]);
  const [goals, setGoals] = useState([]);
  const [recLoading, setRecLoading] = useState(false);
  var QnA = {
    "What are your interests?": "Reading books, watching movies, playing video games.",
    "What subjects do you enjoy in school?": "English and History.",
    "What is your dream career?": "Something to do with writing or art.",
    "Is there anything you wish to study?": "Something to do with English or Art",
    "Have you ever won or competed in any competitions?": "Yes, I have won several writing and art competitions.",

    "What is your budget?": "As low as possible",
    "What country do you reside in?": "Lithuania",
    "Where would you like to study?": "Anywhere in Europe, I would like it to be a mountainous area if possible.",
    "Extra details": "I love nature",
  };

  function sendQnA() {
    
    const answers = document.getElementsByClassName("answer");
    for (let i = 0; i < answers.length; i++) {
      QnA[Object.keys(QnA)[i]] = answers[i].textContent;
    }
    console.log(QnA);
    if(!recLoading){
      setRecLoading(true);
      axios({
        method: 'post',
        url: `${apiUrl}/recommendations`,
        data: QnA
      }).then((response) => {
        setRecLoading(false);
        setUniversityRecommendations(response.data["university_descriptions"]);
        //JSON.parse(goal.replace("```json\n", "").replace("```", ""))
        console.log("Goals: " + response.data["goals"][0])

        setTimeout(() => {
          aos.refresh();
        }, 500);
        
        const goals = response.data["goals"].map(goal => JSON.parse(goal));
        setGoals(goals);
        //console.log(response.data["university_descriptions"])
      }).catch((error) => {
        setRecLoading(false);
        if(error.response.data.error){
          alert.error(error.response.data.error);
        } else {
          alert.error("An error occurred while trying to generate recommendations.");
        }
        console.log(error);
      });
    }
  }

  useEffect(() => {
    aos.init();
    mouseEffect();
    setTimeout(() => {
      aos.refresh();
    }, 500);
  }, []);

  return (
    <>
      <Cookies />
      <NavBar />
      <Banner />
      <main>
        <div className='mainFrame'>
          <About />
          {ifMobile() ? null : null}
          <div className='container' id="TestHeader">
            <div className='header flex text-center'>
              <h5 data-aos="fade-down" data-aos-anchor="#TestHeader">Working demo</h5>
              <h2 data-aos="fade-down" data-aos-anchor="#TestHeader" data-aos-delay="100">Test it out!</h2>
              <p data-aos="fade-down" data-aos-anchor="#TestHeader" data-aos-delay="200">Feel free to test out our current model !</p>
              <p data-aos="fade-down" data-aos-anchor="#TestHeader" data-aos-delay="250"> --- </p>
              <p className='text-red' data-aos="fade-down" data-aos-anchor="#TestHeader" data-aos-delay="300">Note that this is our first model and we're still experimenting, so some unexpected behaviour may occur. Thanks for your understanding.</p>
              <p className='text-red' data-aos="fade-down" data-aos-anchor="#TestHeader" data-aos-delay="300">Also don't forget to report bugs !</p>
            </div>
          </div>
          <div id="QnAArea">
            <div>
              <ul>
                {Object.keys(QnA).map((question, i) => (
                  <li key={question} className={i === Object.keys(QnA).length - 1 ? "last" : ""} data-aos="fade-right" data-aos-anchor="#QnAArea" data-aos-delay={i * 100}>
                    <p className="question">{question}</p>
                    <div className='seperator' />
                    <p className="answer" contentEditable>{QnA[question]}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>    
          <div id='GenerateMindMapButtonDiv'>
            <button id="GenerateMindMapButton" className={recLoading ? "loading" : ""} onClick={() => sendQnA()}>
              {recLoading ? (<span className="loader"></span>) : "Explore my paths"}
            </button>
          </div>
          </div>
          <div id="MindMapDiv">
            <MindMap goalsProp={goals} universityRecommendationsProp={universityRecommendations} QnA={QnA}/>
          </div>  
          <div className='mainFrame'>
            <FeedBack />
            <Team />
        </div>
    </main>
    <Footer />
    </>
  );
}

            /*<Contact />*/
/*
        <h1>Mind Map</h1>
          {universityRecommendations.map((recommendation, index) => (
            <div key={index} className="recommendation open" onClick={() => {
              //const element = document.getElementsByClassName("universityRecommendation")[index];
              //element.classList.toggle("open");
            }}>
              <Markdown remarkPlugins={[remarkGfm]}>{recommendation}</Markdown>
              <ReportBar />
            </div>
          ))}
          <div id="CareeerRecommendations">
            <div className='separatorHorizontal' />
            {
              careerRecommendations.map((recommendation, index) => (
                <div key={index} className="recommendation open" onClick={() => {
                  const element = document.getElementsByClassName("careerRecommendation")[index];
                  //element.classList.toggle("open");
                }}>
                  <Markdown remarkPlugins={[remarkGfm]}>{recommendation}</Markdown>
                  <ReportBar />
                </div>
              ))
            }
          </div>
          */